import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LabelHeader from "../../Components/Commons/LabelHeader";
import TextField from "../../Components/Commons/Forms/TextField";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import Table from "../../Components/Commons/Table/Table";
import { Button, Form, Modal, Row, Tabs, Tab } from "react-bootstrap";
import BtnAdd from "../Commons/Buttons/BtnAdd";
import BtnEdit from "../Commons/Buttons/BtnEdit";
import { DatePicker, Space, Card } from 'antd';
import AntDTable from "../AntDTable/AntDTable";
import './Diagnosis.css'
import SidebarMenu from "../Sidebar/Sidebar";
import DateField from "../Commons/Forms/DateField";
import TextArea from "../Commons/Forms/TextArea";
import PatientCard from "../PatientProfile/PatientCard";
function Diagnosis() {
const navigate = useNavigate();
const {id} = useParams();
const [addDetails, setAddDetails] = useState([]);
const [showLoader, setShowLoader] = useState(false);
const [showForm, setShowForm] = useState(false);
const [hasVitalSigns, setHasVitalSigns] = useState(true);
const [selectedTab, setSelectedTab] = useState("laboratory");
const today = new Date().toISOString().split('T')[0];
const data = [
  {
    key: '1',
    date: "8/15/2023",
    aog: 3,
    weight: 160,
    blood_pressure: 120,
    height: 178,
    heart_rate: 100,
    presentation: "",
  },
  {
    key: '2',
    date: "8/16/2023",
    aog: 5,
    weight: 170,
    blood_pressure: 125,
    height: 178,
    heart_rate: 100,
    presentation: "",
  },
  {
    key: '3',
    date: "8/17/2023",
    aog: 5,
    weight: 170,
    blood_pressure: 125,
    height: 178,
    heart_rate: 100,
    presentation: "",
  },
];
// const [url, setUrl] = useState('https://www.themoviedb.org/t/p/w600_and_h900_bestv2/7Hw2gy9gD6yMeUOHzwhxgIOeGwo.jpg');
// const [patientDetails, setpatientDetails] = useState({
//   name: "Jeno Lee",
//   description: "Nct Dream",
//   allergies: "cat fur",
//   age: "19",
//   sex: "M",
//   status: "Single"
// });
// function handleEdit() {
//   navigate("/patients/edit/" + id)
// }

const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddDetails((prevState) => ({
    ...prevState,
    [name]: value,
    }));
}

  return (
    <div className="App" style={{background: "#ecffcc"}}>
        {/* <SidebarMenu
            active={"Patients"}
        /> */}
        <div className=" add-customer col p-5 pt-4">
            {/* <LabelHeader text={"Diagnostics"} /> */}
            <div className="">
                <div className="row mt-2">
                    {/* <div className="col-sm-3">
                        <PatientCard
                            url={url}
                            patientDetails={patientDetails}
                            onEditClick={handleEdit}
                        />
                    </div> */}
                    <div className="col-sm-12">
                    <label className="col-6 font-bold font-large mb-2">PACKAGES</label>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="cbc"
                                    name="cbc"
                                    formLabel={`Basic Check-up`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.cbc}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="blood_type"
                                    name="blood_type"
                                    formLabel={`Dialysis Panel A`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.blood_type}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="hbsag"
                                    name="hbsag"
                                    formLabel={`Dialysis Panel B`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.hbsag}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="hiv"
                                    name="hiv"
                                    formLabel={`Dialysis Panel C`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.hiv}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="vdrl_tpha"
                                    name="vdrl_tpha"
                                    formLabel={`Renal Panel C`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.vdrl_tpha}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="fbs"
                                    name="fbs"
                                    formLabel={`Diabetic Panel`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.fbs}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="ogtt_75_gm"
                                    name="ogtt_75_gm"
                                    formLabel={`Liver Profile`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.ogtt_75_gm}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="albumin"
                                    name="albumin"
                                    formLabel={`Lipid Profile`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.albumin}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <label className="col-6 font-bold font-large mb-2">Laboratory</label>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="alkaline_phosphatase"
                                    name="alkaline_phosphatase"
                                    formLabel={`75 gm OGTT`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.alkaline_phosphatase}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="amylase"
                                    name="amylase"
                                    formLabel={`Albumin`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.amylase}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="basic_checkup_labs"
                                    name="basic_checkup_labs"
                                    formLabel={`Alkaline Phospatase`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.basic_checkup_labs}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="bua"
                                    name="bua"
                                    formLabel={`Amylase`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.bua}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="bun"
                                    name="bun"
                                    formLabel={`BUA`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.bun}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="creatinine"
                                    name="creatinine"
                                    formLabel={`BUN`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.creatinine}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="egfr"
                                    name="egfr"
                                    formLabel={`CBC`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.egfr}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="fsh"
                                    name="fsh"
                                    formLabel={`Creatinine`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.fsh}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="ft3"
                                    name="ft3"
                                    formLabel={`eGFR`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.ft3}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="ft4"
                                    name="ft4"
                                    formLabel={`FBS`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.ft4}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="hba1c"
                                    name="hba1c"
                                    formLabel={`FT3`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.hba1c}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="indirect_bilirubin"
                                    name="indirect_bilirubin"
                                    formLabel={`FT4`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.indirect_bilirubin}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="ionized_calcium"
                                    name="ionized_calcium"
                                    formLabel={`Hb1c`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.ionized_calcium}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="lipid_profile"
                                    name="lipid_profile"
                                    formLabel={`Indirect Bilirubin`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.lipid_profile}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="magnesium"
                                    name="magnesium"
                                    formLabel={`Ionized Calcium`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.magnesium}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="micral_test"
                                    name="micral_test"
                                    formLabel={`Lipid Profile`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.micral_test}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="pap_smear"
                                    name="pap_smear"
                                    formLabel={`Magnesium`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.pap_smear}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="phosphorus"
                                    name="phosphorus"
                                    formLabel={`Micral Test`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.phosphorus}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="potassium"
                                    name="potassium"
                                    formLabel={`Phosphorus`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.potassium}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="rbs"
                                    name="rbs"
                                    formLabel={`Potassium`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.rbs}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="sars_cov2_antigen_swab"
                                    name="sars_cov2_antigen_swab"
                                    formLabel={`RBS`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.sars_cov2_antigen_swab}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="sars_cov2_clia"
                                    name="sars_cov2_clia"
                                    formLabel={`SGOT`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.sars_cov2_clia}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="sars_cov2_rt_pcr"
                                    name="sars_cov2_rt_pcr"
                                    formLabel={`SGPT`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.sars_cov2_rt_pcr}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="serum_estradiol"
                                    name="serum_estradiol"
                                    formLabel={`Sodium`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.serum_estradiol}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="serum_fsh"
                                    name="serum_fsh"
                                    formLabel={`Stool Exam`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.serum_fsh}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="serum_prolactin"
                                    name="serum_prolactin"
                                    formLabel={`T3`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.serum_prolactin}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="sgot"
                                    name="sgot"
                                    formLabel={`T4`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.sgot}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="sgpt"
                                    name="sgpt"
                                    formLabel={`Total Bilirubin`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.sgpt}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="sodium"
                                    name="sodium"
                                    formLabel={`Total Calcium`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.sodium}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="stool_exam"
                                    name="stool_exam"
                                    formLabel={`TSH`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.stool_exam}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="t3"
                                    name="t3"
                                    formLabel={`Urinalysis`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.t3}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="t4"
                                    name="t4"
                                    formLabel={`Urine Ketones`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.t4}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <TextField
                                    id="others"
                                    name="others"
                                    formLabel={`Others`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.others}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <label className="col-6 font-bold font-large mb-2">SPECIAL TEST</label>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="urine_metanephrines"
                                    name="urine_metanephrines"
                                    formLabel={`24-urine Metanephrines`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.urine_metanephrines}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="serum_cortisol"
                                    name="serum_cortisol"
                                    formLabel={`8 am Serum Cortisol`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.serum_cortisol}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="anti_thyroglobulin"
                                    name="anti_thyroglobulin"
                                    formLabel={`Anti-thyroglobulin`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.anti_thyroglobulin}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="basic_checkup_labs"
                                    name="basic_checkup_labs"
                                    formLabel={`IGF-1`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.basic_checkup_labs}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="igf1"
                                    name="igf1"
                                    formLabel={`Intact PTH`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.igf1}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="intact_pth"
                                    name="intact_pth"
                                    formLabel={`Plasma Insulin`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.intact_pth}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="plasma_insulin"
                                    name="plasma_insulin"
                                    formLabel={`Plasma Renin Activity`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.plasma_insulin}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="plasma_renin_activity"
                                    name="plasma_renin_activity"
                                    formLabel={`Serum Aldosterone`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.plasma_renin_activity}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="serum_aldosterone"
                                    name="serum_aldosterone"
                                    formLabel={`Thyroglobulin`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.serum_aldosterone}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <label className="col-6 font-bold font-large mb-2">RADIOLOGY</label>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="ecg_12l"
                                    name="ecg_12l"
                                    formLabel={`12-L ECG`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.ecg_12l}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="echo_with_doppler"
                                    name="echo_with_doppler"
                                    formLabel={`2D ECHO WITH DOPPLER`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.echo_with_doppler}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="aog"
                                    name="aog"
                                    formLabel={`Chest X-Ray Lateral View`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.aog}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="chest_xray_lateral_view"
                                    name="chest_xray_lateral_view"
                                    formLabel={`Chest X-Ray PA View`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.chest_xray_lateral_view}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="chest_xray_pa_view"
                                    name="chest_xray_pa_view"
                                    formLabel={`Ultrasound`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.chest_xray_pa_view}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="mammogram"
                                    name="mammogram"
                                    formLabel={`Scan`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.mammogram}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                            <div className="col-sm-3">
                                <DateField
                                    min={today}
                                    id="others"
                                    name="others"
                                    formLabel={`Others`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    value={addDetails.mammogram_and_breast_ultrasound}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="row mt-3">
                                <label className="col-6 font-bold mb-2">Fasting</label>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <Form.Check
                                            type="checkbox"
                                            label="Fasting 8-10 Hours"
                                            name="fasting_8_10_hours"
                                            // value="1"
                                            className="pt-2"
                                            onChange={(e) => handleAddChange(e)}
                                        />
                                    </div>
                                    <div className="col-sm-3">
                                        <Form.Check
                                            type="checkbox"
                                            label="Fasting 10-12 hrs"
                                            name="fasting_10_12_hours"
                                            // value="1"
                                            className="pt-2"
                                            onChange={(e) => handleAddChange(e)}
                                        />
                                    </div>
                                    <div className="col-sm-3">
                                        <Form.Check
                                            type="checkbox"
                                            label="No Fasting Needed"
                                            name="no_fasting_needed"
                                            // value="1"
                                            className="pt-2"
                                            onChange={(e) => handleAddChange(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <hr/>
                            {/* <div className="row mt-3">
                                <div className="col-sm-12">
                                <TextArea
                                    id="notes"
                                    name="notes"
                                    formLabel={`Notes`}
                                    size={`sm`}
                                    onChange={handleAddChange}
                                    // isError={}
                                    errorMessage="This is an error"
                                />
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="row justify-content-end mt-2 mb-3">
                {/* {
                    hasVitalSigns && (
                        <div className="col-2">
                            <BtnEdit label={"EDIT"} size={"sm"} />
                        </div>
                    )
                } */}
                <div className="col-2">
                    <BtnSave label={"Save Diagnostics"} size={"sm"} onClick={() => navigate(-1)} />
                </div>
            </div>
        </div>
    </div>
  );
}

export default Diagnosis;